import {Backbone} from 'Vertebrae';
import {Concentration} from '../model/concentration';

export const Concentrations = Backbone.Collection.extend({
    _name: 'Concentrations',
    model: Concentration,
});
